import 'isomorphic-fetch';

export default class Fetcher {
  async getJson(url, token) {
    const headers = token ? {
      Authorization: `Bearer ${token}`,
    } : {};

    const settings = {
      method: 'get',
      mode: 'cors',
      headers,
    };

    const response = await fetch(url, settings);

    return response.json();
  }
}



// WEBPACK FOOTER //
// ./src/Auth/providers/Fetcher.js